import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'home',
  init() {
    const HomeDyReporter = Vue.component('home-dy-reporter', () =>
      import(/* webpackChunkName: "home-dy-reporter" */ './HomeDyReporter.vue')
    )
    newVue({
      render: h => h(HomeDyReporter),
      mount: '.js-vue-home-dy-reporter',
    })
  },
})
